/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


//   $(function(){
//     $(".AspectRatio").each(function(){
//           const alt = $(this).attr("alt");
//           const captext = alt.slice(0,4);
//           const caption = alt.slice(4,100)
//           console.log(caption);
//           if ('cap:' == captext){
//               $(".caption").prepend(caption);
//               }else{;}
//       });
//   });


// element fade-in
$(function() {
	$(window).scroll(function() {
		$('.fadein').each(function() {
			var elemPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > elemPos - windowHeight) {
				$(this).addClass('slidein');
			}
		});
	});
});


// scroll bar customize
$(function() {
	$(".scroll-area").mCustomScrollbar();
});


// 商品詳細アコーディオン
$(function() {
	const toggle = $('.ProductMeta__DetailsWrap .view-more');
	const content = $('.ProductMeta__DetailsWrap .js-ToggleContent');
	$(toggle).click(function() {
		$(this).toggleClass('is-open');
		$(this).next(content).slideToggle();
	});
});


// ギフトラッピング　ページ内リンク
$(function() {
	const button = $('.ProductMeta__giftButton');
	const toggle = $('#ProductMeta__gift .view-more');
	const content = $('#ProductMeta__gift .js-ToggleContent');
	$(button).click(function() {
		$(toggle).addClass('is-open');
		$(toggle).next(content).slideDown();
	});
});

// 商品スペック　ページ内リンク
$(function() {
	const button = $('.ProductMeta__detailButton');
	const toggle = $('#ProductMeta__Detail .view-more');
	const content = $('#ProductMeta__Detail .js-ToggleContent');
	$(button).click(function() {
		$(toggle).addClass('is-open');
		$(toggle).next(content).slideDown();
	});
});




// member comment slider
const swiper = new Swiper('.member-comment', {
	// Optional parameters
	loop: true,
	loopAdditionalSlides: 1,
	slidesPerView: 1,
	spaceBetween: 10,
	centeredSlides: true,

	// If we need pagination
	pagination: {
		el: '.swiper-pagination',
	},

	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});


// Instagram feed
$(function() {
	let list = '';
	const limit = '12'; //表示件数
	const accessToken = 'EAAQhqEesZCkIBAGspG96xgfMGQC0zZBDBb8ot8QlIkIBd4Jas5nJQcf3W8fmJLV0xlY4mGq3r4kLZBwc61XghMZA3DzNPZAHGPrxnzxBKY3ZBDRfnHcaHaBsjv1e9aNoSXSoVNbPfa6zfPKJZBHaim0xlUkCtU2200KaXmrQTRxe3YPJcS9g4zfaozMi8m076QRWRi8VnDWAgZDZD'; // アクセストークン
	const businessID = '17841443798316549'; //instagram_business_accountのID
	const url = `https://graph.facebook.com/v10.0/${businessID}?fields=name,media.limit(${limit}){caption,media_url,thumbnail_url,permalink,like_count,comments_count,media_type}&access_token=${accessToken}`;
	$.ajax({
		url: url
	}).done((res) => {
		const data = res.media;
		$.each(data, function(index, val) {
			$.each(val, function(i, item) {
				console.log(item);
				if (item.media_url) {
					//メディアのタイプがビデオの場合、サムネを取得
					media = (item.media_type == 'VIDEO' ? item.thumbnail_url : item.media_url);

					// 一覧を変数listに格納
					list +=
						`<li>
            <a href="${item.permalink}" target="_blank" rel="noopener">
            <img src="${media}">
          </li>`;
				}

			})
		});
		$('.InstagramFeed').html(`${list}`);
	}).fail(function(jqXHR, status) {
		$('#section-instagram-feed').css('display', 'none');
	});
});


// コレクションページ　Read more
$(function() {
	$('.description--more button').on('click', function() {
		//クリックしたボタンの親要素にクラスを付与
		const parent = $(this).closest('.description');
		const content = parent.find('.description--content');
		parent.toggleClass('is-open');
		//クラスの有無で条件分岐
		if (parent.hasClass('is-open')) {
			//スクロール領域も含めた高さを取得・付与する
			const height = content.get(0).scrollHeight;
			content.css('height', height);
			//テキストを変更する
			$(this).text('閉じる')
		} else {
			//高さを戻す
			content.css('height', '');
			//テキストを戻す
			$(this).text('続きを見る');
		}
	});
});


// SlideBanner用のSplide初期化処理
function initializeSlideBanner() {
	// スライドバナーセクションのSplide初期化
	const slideBannerSections = document.querySelectorAll('.s-slideBanner .splide');
	
	slideBannerSections.forEach(function(splideElement) {
		// 既存のSplideインスタンスがある場合は破棄
		if (splideElement.splide) {
			// Splideインスタンスを破棄
			splideElement.splide.destroy();
		}
		
		// セクション全体のクリーンアップ
		const section = splideElement.closest('.s-slideBanner');
		if (section) {
			// 残ったDOM要素を削除（ページネーション、矢印等）
			const existingPagination = section.querySelectorAll('.splide__pagination');
			existingPagination.forEach(pagination => pagination.remove());
			
			const existingArrows = section.querySelectorAll('.splide__arrow');
			existingArrows.forEach(arrow => arrow.remove());
			
			// Splideが追加したクラスを削除
			const splideElements = section.querySelectorAll('.splide');
			splideElements.forEach(element => {
				element.classList.remove('is-initialized');
				element.classList.remove('is-active');
			});
		}
		
		// 設定を取得
		let config = {};
		
		// data-splide-config属性から設定を取得
		if (splideElement.hasAttribute('data-splide-config')) {
			try {
				config = JSON.parse(splideElement.getAttribute('data-splide-config'));
			} catch (e) {
				console.warn('Splide config parse error:', e);
			}
		}
		
		// デフォルト設定
		const defaultConfig = {
			type: 'loop',
			perPage: 4,
			focus: 'center',
			autoplay: true,
			interval: 5000,
			pauseOnHover: false,
			pagination: true,
			arrows: false,
			drag: true,
			dragMinThreshold: 15
		};
		
		// 設定をマージ（Liquidファイルの設定が優先）
		const finalConfig = Object.assign({}, defaultConfig, config);
		
		// Splideインスタンスを作成
		const splide = new Splide(splideElement, finalConfig);
		
		// スライド変更時のイベント
		splide.on('moved', function(newIndex, prevIndex, destIndex) {
			const slide = splide.Components.Elements.slides[newIndex];
			if (slide) {
				// スライド変更時のアニメーション処理
				handleSlideBannerChange(slide);
			}
		});
		
		// Splideをマウント
		splide.mount();
	});
}

// ページ読み込み時の初期化
document.addEventListener('DOMContentLoaded', function() {
	initializeSlideBanner();
	initializeFeaturedPages();
});

// テーマエディタ環境でのセクション動的更新に対応
document.addEventListener('shopify:section:load', function(event) {
	// スライドバナーセクションが更新された場合のみ初期化
	if (event.target.classList.contains('s-slideBanner')) {
		// 少し遅延を入れてDOMの更新を待つ
		setTimeout(function() {
			initializeSlideBanner();
		}, 100);
	}
	
	// featured-pagesセクションが更新された場合のみ初期化
	if (event.target.classList.contains('s-featuredPages')) {
		setTimeout(function() {
			initializeFeaturedPages();
		}, 100);
	}
});

// テーマエディタ環境でのセクション選択時にも初期化
document.addEventListener('shopify:section:select', function(event) {
	if (event.target.classList.contains('s-slideBanner')) {
		setTimeout(function() {
			initializeSlideBanner();
		}, 100);
	}
	
	if (event.target.classList.contains('s-featuredPages')) {
		setTimeout(function() {
			initializeFeaturedPages();
		}, 100);
	}
});

// featured-pagesセクションのSplide初期化
function initializeFeaturedPages() {
	const featuredPagesSections = document.querySelectorAll('.s-featuredPages .splide');
	
	featuredPagesSections.forEach(function(splideElement) {
		// 既存のSplideインスタンスがある場合は破棄
		if (splideElement.splide) {
			splideElement.splide.destroy();
		}
		
		// セクション全体のクリーンアップ
		const section = splideElement.closest('.s-featuredPages');
		if (section) {
			// 残ったDOM要素を削除（ページネーション、矢印等）
			const existingPagination = section.querySelectorAll('.splide__pagination');
			existingPagination.forEach(pagination => pagination.remove());
			
			const existingArrows = section.querySelectorAll('.splide__arrow');
			existingArrows.forEach(arrow => arrow.remove());
			
			// Splideが追加したクラスを削除
			const splideElements = section.querySelectorAll('.splide');
			splideElements.forEach(element => {
				element.classList.remove('is-initialized');
				element.classList.remove('is-active');
			});
		}
		
		// 設定を取得
		let config = {};
		
		// data-splide-config属性から設定を取得
		if (splideElement.hasAttribute('data-splide-config')) {
			try {
				config = JSON.parse(splideElement.getAttribute('data-splide-config'));
			} catch (e) {
				console.warn('Splide config parse error:', e);
			}
		}
		
		// デフォルト設定
		const defaultConfig = {
			type: 'loop',
			perPage: 2.5,
			focus: 'center',
			autoplay: false,
			pagination: false,
			arrows: true,
			drag: true,
			dragMinThreshold: 15,
			gap: 20,
			breakpoints: {
				640: {
					perPage: 1,
					arrows: false,
					pagination: true
				}
			}
		};
		
		// 設定をマージ（Liquidファイルの設定が優先）
		const finalConfig = Object.assign({}, defaultConfig, config);
		
		// Splideインスタンスを作成
		const splide = new Splide(splideElement, finalConfig);
		
	// Splideをマウント
	splide.mount();
});
}

// カートページの数量更新処理
(function() {
	'use strict';

	// カートページかどうかを判定
	const isCartPage = window.theme && window.theme.pageType === 'cart';

	// リクエスト中の状態管理（重複リクエストを防ぐ）
	const pendingRequests = new Map();

	// リロード中のフラグ（リロードの重複を防ぐ）
	let isReloading = false;
	
	// エラー発生フラグ（エラーが発生した場合はリロードを防ぐ）
	let hasError = false;

	// 数量更新ボタンのイベントリスナー
	function initCartQuantityHandlers() {
		// 数量ボタン（+/-）
		const quantityButtons = document.querySelectorAll('.js-quantityButton');
		quantityButtons.forEach(function(button) {
			button.addEventListener('click', function(event) {
				event.preventDefault();
				event.stopPropagation();
				updateItemQuantity(event, button);
			});
		});

		// 数量入力フィールド
		const quantityInputs = document.querySelectorAll('.quantitySelector--currentQuantity');
		quantityInputs.forEach(function(input) {
			input.addEventListener('change', function(event) {
				updateItemQuantity(event, input);
			});
		});

		// 削除ボタン
		const removeButtons = document.querySelectorAll('.js-removeItem');
		removeButtons.forEach(function(button) {
			button.addEventListener('click', function(event) {
				event.preventDefault();
				event.stopPropagation();
				updateItemQuantity(event, button);
			});
		});
	}

	// 数量更新処理
	function updateItemQuantity(event, target) {
		// デフォルトの動作を防止
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}

		// リロード中の場合は新しいリクエストを無視
		if (isReloading) {
			return;
		}
		
		// エラー発生中の場合は、一定時間経過後にリセット（レート制限エラーの場合のみ）
		// 在庫エラーの場合は、ユーザーが数量を変更するまでエラー状態を維持
		if (hasError) {
			// レート制限エラーの場合は、5秒後にリセット（再試行可能にする）
			// 在庫エラーの場合は、ユーザーが数量を変更するまで待つ
			const lastErrorTime = window.lastCartErrorTime || 0;
			const now = Date.now();
			if (now - lastErrorTime > 5000) {
				// 5秒経過した場合はエラーフラグをリセット（レート制限エラーの可能性）
				hasError = false;
			} else {
				// 5秒以内の場合はリクエストを無視
				return;
			}
		}

		const lineId = target.getAttribute('data-line-id');
		
		// 同じline-idのリクエストが既に処理中の場合は無視
		if (pendingRequests.has(lineId)) {
			return;
		}

		// ローディング開始
		document.dispatchEvent(new CustomEvent('theme:loading:start'));

		let quantity = null;

		if (target.tagName === 'INPUT') {
			quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
		} else {
			quantity = parseInt(target.getAttribute('data-quantity'));
		}

		// リクエストURLとボディ
		const requestUrl = window.routes.cartChangeUrl;
		const requestBody = {
			id: lineId,
			quantity: quantity,
			sections: [],
			sections_url: window.location.pathname
		};

		// リクエスト中フラグを設定
		pendingRequests.set(lineId, true);

		fetch(requestUrl, {
			body: JSON.stringify(requestBody),
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			}
		}).then(function(response) {
			// Prestigeテーマの実装に合わせて、エラー時は即座に処理を終了
			// レート制限エラー（429）の処理
			if (response.status === 429) {
				// リクエスト完了フラグを解除
				pendingRequests.delete(lineId);
				// エラーフラグを設定（リロードを防ぐ）
				hasError = true;
				// エラー発生時刻を記録（リセット用）
				window.lastCartErrorTime = Date.now();
				return Promise.reject({
					type: 'rate_limit_error',
					status: 429,
					content: null,
					responseText: 'リクエストが多すぎます。しばらくしてから再度お試しください。'
				});
			}

			// エラーレスポンスの処理（422など）
			// Prestigeテーマのように、!response.okの場合は即座にエラー処理
			if (!response.ok) {
				return response.text().then(function(text) {
					// リクエスト完了フラグを解除
					pendingRequests.delete(lineId);
					// エラーフラグを設定（リロードを防ぐ）
					hasError = true;
					// エラー発生時刻を記録（在庫エラーの場合はリセットしない）
					// レート制限エラー（429）の場合は既に設定済み
					if (response.status !== 429) {
						window.lastCartErrorTime = Date.now();
					}
					try {
						const errorContent = JSON.parse(text);
						return Promise.reject({
							type: 'api_error',
							status: response.status,
							content: errorContent,
							responseText: text
						});
					} catch (e) {
						return Promise.reject({
							type: 'api_error',
							status: response.status,
							content: null,
							responseText: text
						});
					}
				});
			}

			// 成功レスポンスのみ処理を続行
			return response.text();
		}).then(function(state) {
			// JSONをパース
			let parsedState;
			try {
				parsedState = JSON.parse(state);
			} catch (e) {
				// パースエラー時もリクエスト完了フラグを解除
				const lineId = target.getAttribute('data-line-id');
				pendingRequests.delete(lineId);
				hasError = true;
				throw new Error('Failed to parse response');
			}

			const lineId = target.getAttribute('data-line-id');
			// リクエスト完了フラグを解除（成功時）
			pendingRequests.delete(lineId);
			
			// 同じIDが複数存在する可能性があるため、すべてのエラー要素を取得
			const lineItemErrors = document.querySelectorAll('[id="Line-item-error-' + lineId + '"]');

			// エラーチェック（parsedState.errorsが存在し、空でない場合）
			// Riseテーマのように、parsedState.errorsがある場合は即座にreturn
			if (parsedState.errors && (
				(typeof parsedState.errors === 'string' && parsedState.errors.trim() !== '') ||
				(Array.isArray(parsedState.errors) && parsedState.errors.length > 0) ||
				(typeof parsedState.errors === 'object' && Object.keys(parsedState.errors).length > 0)
			)) {
				// エラーフラグを設定（リロードを防ぐ）
				hasError = true;
				
				// エラーメッセージを表示（すべてのエラー要素を更新）
				if (lineItemErrors.length > 0) {
					// ネットワークエラーやブラウザのセキュリティ警告をチェック
					const errorTextStr = typeof parsedState.errors === 'string' ? parsedState.errors : JSON.stringify(parsedState.errors);
					const isNetworkError = errorTextStr && (
						errorTextStr.includes('続行するには接続の確認が必要') ||
						errorTextStr.includes('このアドレスからは') ||
						errorTextStr.includes('Web サイトにアクセスできません')
					);
					
					// ネットワークエラーの場合はカスタムメッセージを表示
					if (isNetworkError) {
						const errorMessage = '通信エラーが発生しました。しばらくしてから再度お試しください。';
						lineItemErrors.forEach(function(lineItemError) {
							const errorText = lineItemError.querySelector('.cartItem--errorText');
							if (errorText) {
								errorText.textContent = errorMessage;
								lineItemError.style.setProperty('display', 'block', 'important');
							}
						});
						document.dispatchEvent(new CustomEvent('theme:loading:end'));
						return;
					}
					
					// 在庫数を取得（data属性から）
					let maxQuantity = null;
					const lineId = target.getAttribute('data-line-id');
					
					// targetがボタンの場合、同じline-idの入力フィールドから在庫数を取得
					let inputElement = target;
					if (target.tagName !== 'INPUT') {
						inputElement = document.querySelector('input[data-line-id="' + lineId + '"]');
					}
					
					if (inputElement) {
						const inventoryQuantityAttr = inputElement.getAttribute('data-inventory-quantity');
						if (inventoryQuantityAttr !== null && inventoryQuantityAttr !== '') {
							maxQuantity = parseInt(inventoryQuantityAttr);
						}
					}
					
					// parsedState.itemsから該当アイテムの在庫数を取得（フォールバック）
					if (maxQuantity === null && parsedState.items && Array.isArray(parsedState.items)) {
						const currentItem = parsedState.items.find(function(item) {
							return item.key === lineId;
						});
						if (currentItem && currentItem.variant && currentItem.variant.inventory_quantity !== null) {
							maxQuantity = currentItem.variant.inventory_quantity;
						}
					}
					
					// カスタムメッセージを生成
					let errorMessage = '在庫数を超える数量は選択できません';
					if (maxQuantity !== null && !isNaN(maxQuantity) && maxQuantity >= 0) {
						errorMessage = 'この商品は' + maxQuantity + '点まで購入可能です';
					}
					
					lineItemErrors.forEach(function(lineItemError) {
						const errorText = lineItemError.querySelector('.cartItem--errorText');
						if (errorText) {
							errorText.textContent = errorMessage;
							lineItemError.style.setProperty('display', 'block', 'important');
						}
					});
				}

				// 数量を元に戻す
				if (target.tagName === 'INPUT') {
					const originalQuantity = target.getAttribute('data-original-quantity') || target.defaultValue;
					target.value = originalQuantity;
				}

				document.dispatchEvent(new CustomEvent('theme:loading:end'));
				// エラーが発生した場合はリロードを実行しない
				return;
			}
			
			// エラーがない場合はエラーフラグをリセット
			hasError = false;
			// エラー発生時刻もリセット
			window.lastCartErrorTime = 0;

			// エラーメッセージを非表示（すべてのエラー要素を更新）
			if (lineItemErrors.length > 0) {
				lineItemErrors.forEach(function(lineItemError) {
					lineItemError.style.setProperty('display', 'none', 'important');
					const errorText = lineItemError.querySelector('.cartItem--errorText');
					if (errorText) {
						errorText.textContent = '';
					}
				});
			}

			// カートページの場合はリロード
			// Prestigeテーマのように、成功時のみリロードを実行
			// エラーがない場合のみリロードを実行（hasErrorフラグで確実に防ぐ）
			if (isCartPage && !isReloading && !hasError) {
				// ローディングを確実に終了
				document.dispatchEvent(new CustomEvent('theme:loading:end'));
				
				// リロード中のフラグを設定
				isReloading = true;
				
				// Prestigeテーマのように、即座にリロード（遅延なし）
				// エラーチェックは既に完了しているため、ここに到達した時点で成功が確定
				window.location.reload();
				return;
			}

			// ドロワーの場合は再レンダリング（theme.jsの処理に委譲）
			document.dispatchEvent(new CustomEvent('theme:loading:end'));
		}).catch(function(error) {
			// エラーハンドリング
			const lineId = target.getAttribute('data-line-id');
			
			// リクエスト完了フラグを解除
			pendingRequests.delete(lineId);
			
			// エラーフラグを設定（リロードを防ぐ）
			hasError = true;
			
			// 同じIDが複数存在する可能性があるため、すべてのエラー要素を取得
			const lineItemErrors = document.querySelectorAll('[id="Line-item-error-' + lineId + '"]');

			if (lineItemErrors.length > 0) {
				// レート制限エラー（429）の処理
				if (error && error.type === 'rate_limit_error') {
					const errorMessage = 'リクエストが多すぎます。しばらくしてから再度お試しください。';
					lineItemErrors.forEach(function(lineItemError) {
						const errorText = lineItemError.querySelector('.cartItem--errorText');
						if (errorText) {
							errorText.textContent = errorMessage;
							lineItemError.style.setProperty('display', 'block', 'important');
						}
					});
					document.dispatchEvent(new CustomEvent('theme:loading:end'));
					return;
				}

				// ネットワークエラーやブラウザのセキュリティ警告をチェック
				const isNetworkError = error && (
					error.responseText && (
						error.responseText.includes('続行するには接続の確認が必要') ||
						error.responseText.includes('このアドレスからは') ||
						error.responseText.includes('Web サイトにアクセスできません')
					) ||
					error.type === 'network_error' ||
					error.message && error.message.includes('Failed to fetch')
				);
				
				// ネットワークエラーの場合はカスタムメッセージを表示
				if (isNetworkError) {
					const errorMessage = '通信エラーが発生しました。しばらくしてから再度お試しください。';
					lineItemErrors.forEach(function(lineItemError) {
						const errorText = lineItemError.querySelector('.cartItem--errorText');
						if (errorText) {
							errorText.textContent = errorMessage;
							lineItemError.style.setProperty('display', 'block', 'important');
						}
					});
					document.dispatchEvent(new CustomEvent('theme:loading:end'));
					return;
				}
				
				// 在庫数を取得（data属性から）
				let maxQuantity = null;
				const lineId = target.getAttribute('data-line-id');
				
				// targetがボタンの場合、同じline-idの入力フィールドから在庫数を取得
				let inputElement = target;
				if (target.tagName !== 'INPUT') {
					inputElement = document.querySelector('input[data-line-id="' + lineId + '"]');
				}
				
				if (inputElement) {
					const inventoryQuantityAttr = inputElement.getAttribute('data-inventory-quantity');
					if (inventoryQuantityAttr !== null && inventoryQuantityAttr !== '') {
						maxQuantity = parseInt(inventoryQuantityAttr);
					}
				}
				
				// error.contentから在庫数情報を取得を試みる（フォールバック）
				if (maxQuantity === null && error && error.content) {
					// エラーメッセージから数量を抽出する試み
					const errorText = error.content.description || error.content.message || '';
					const quantityMatch = errorText.match(/(\d+)\s*点/);
					if (quantityMatch) {
						maxQuantity = parseInt(quantityMatch[1]);
					}
					
					// items配列から在庫数を取得
					if (maxQuantity === null && error.content.items && Array.isArray(error.content.items)) {
						const currentItem = error.content.items.find(function(item) {
							return item.key === lineId;
						});
						if (currentItem && currentItem.variant && currentItem.variant.inventory_quantity !== null) {
							maxQuantity = currentItem.variant.inventory_quantity;
						}
					}
				}
				
				// カスタムメッセージを生成
				let errorMessage = '在庫数を超える数量は選択できません';
				if (maxQuantity !== null && !isNaN(maxQuantity) && maxQuantity >= 0) {
					errorMessage = 'この商品は' + maxQuantity + '点まで購入可能です';
				}

				// すべてのエラー要素を更新
				lineItemErrors.forEach(function(lineItemError) {
					const errorText = lineItemError.querySelector('.cartItem--errorText');
					if (errorText) {
						errorText.textContent = errorMessage;
						lineItemError.style.setProperty('display', 'block', 'important');
					}
				});
			}

			// 数量を元に戻す
			if (target.tagName === 'INPUT') {
				const originalQuantity = target.getAttribute('data-original-quantity') || target.defaultValue;
				target.value = originalQuantity;
			}

			document.dispatchEvent(new CustomEvent('theme:loading:end'));
		});
	}

	// ページ読み込み時に初期化
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function() {
			if (isCartPage) {
				initCartQuantityHandlers();
			}
		});
	} else {
		if (isCartPage) {
			initCartQuantityHandlers();
		}
	}
})();

// 商品リスト：スタッガー表示 + カルーセル高さ補正
(function() {
	'use strict';

	var STAGGER_DELAY_MS = 80;
	var observedItems = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
	var staggerObserver = null;

	function revealItem(item, indexInBatch) {
		window.setTimeout(function() {
			item.classList.add('is-visible');
		}, indexInBatch * STAGGER_DELAY_MS);
	}

	function resizeProductListCarousels(root) {
		var scope = root && root.querySelectorAll ? root : document;
		var carousels = scope.querySelectorAll('[data-flickity-config]');

		Array.prototype.forEach.call(carousels, function(element) {
			var flickityInstance = null;

			if (typeof Flickity !== 'undefined' && typeof Flickity.data === 'function') {
				flickityInstance = Flickity.data(element);
			}

			if (flickityInstance && typeof flickityInstance.resize === 'function') {
				flickityInstance.resize();
			}
		});
	}

	function scheduleCarouselResize(root) {
		resizeProductListCarousels(root);
		window.requestAnimationFrame(function() {
			resizeProductListCarousels(root);
		});
		window.setTimeout(function() {
			resizeProductListCarousels(root);
		}, 100);
		window.setTimeout(function() {
			resizeProductListCarousels(root);
		}, 350);
	}

	function observeProductListItems(root) {
		var scope = root && root.querySelectorAll ? root : document;
		var items = scope.querySelectorAll('.js-productListItem:not(.is-visible)');

		if (!items.length) {
			scheduleCarouselResize(scope);
			return;
		}

		if (!('IntersectionObserver' in window)) {
			Array.prototype.forEach.call(items, function(item) {
				item.classList.add('is-visible');
			});
			scheduleCarouselResize(scope);
			return;
		}

		if (!staggerObserver) {
			staggerObserver = new IntersectionObserver(function(entries) {
				var batchIndex = 0;
				entries.forEach(function(entry) {
					if (!entry.isIntersecting && entry.intersectionRatio <= 0) {
						return;
					}
					staggerObserver.unobserve(entry.target);
					revealItem(entry.target, batchIndex);
					batchIndex += 1;
				});
			}, {
				threshold: 0.15,
				rootMargin: '0px 0px -40px 0px'
			});
		}

		Array.prototype.forEach.call(items, function(item) {
			// カルーセル内は高さ計測のため即表示
			if (item.classList.contains('productList--item-carousel')) {
				item.classList.add('is-visible');
				if (observedItems) {
					observedItems.add(item);
				}
				return;
			}

			if (observedItems && observedItems.has(item)) {
				return;
			}
			if (observedItems) {
				observedItems.add(item);
			}
			staggerObserver.observe(item);
		});

		scheduleCarouselResize(scope);
	}

	function initProductListSort() {
		document.addEventListener('change', function(event) {
			var select = event.target.closest('.js-productListSort');
			if (!select) {
				return;
			}

			var url = new URL(window.location.href);
			url.searchParams.set('sort_by', select.value);
			url.searchParams.delete('page');
			window.location.href = url.toString();
		});
	}

	function initProductList() {
		observeProductListItems(document);
		initProductListSort();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initProductList);
	} else {
		initProductList();
	}

	document.addEventListener('shopify:section:load', function(event) {
		observeProductListItems(event.target);
	});

	// 画像遅延読み込み完了後に Flickity 高さを再計算
	document.addEventListener('lazyloaded', function(event) {
		var carousel = event.target.closest('[data-flickity-config]');
		if (carousel) {
			scheduleCarouselResize(carousel.parentNode || document);
		}
	});

	var productListMutationRoot = document.body;
	if (productListMutationRoot && 'MutationObserver' in window) {
		var debounceTimer = null;
		var mutationObserver = new MutationObserver(function() {
			window.clearTimeout(debounceTimer);
			debounceTimer = window.setTimeout(function() {
				observeProductListItems(document);
			}, 100);
		});
		mutationObserver.observe(productListMutationRoot, {
			childList: true,
			subtree: true
		});
	}

	window.ichijituObserveProductList = observeProductListItems;
})();


// 商品詳細：選択中バリエーションが在庫切れの時に再入荷通知ボタンを表示
// ChatBoost の通知登録は商品単位のため、href（state）はバリエーションで変えない
document.addEventListener('variant:changed', function(event) {
	var restockNotion = event.target.querySelector('.js-restockNotion');
	if (!restockNotion) {
		return;
	}

	var variant = event.detail && event.detail.variant;
	restockNotion.hidden = !variant || variant.available;
});

